
import { defineComponent, PropType } from "vue";
import axios from "axios";
import Button from "@/components/buttons/Button.vue";
import { FormValues } from "@/views/quiz-form/QuizForm.vue";
import Loader from "@/components/loader/Loader.vue";
import FetchingError from "@/components/fetching-error/FetchingError.vue";
import Heading2 from "@/components/headings/Heading2.vue";

type QuizResults = {
  correct: number;
  total: number;
};

export default defineComponent({
  name: "QuizResults",
  components: {
    Button,
    Loader,
    FetchingError,
    Heading2,
  },
  emits: ["onClick"],
  props: {
    formValues: {
      type: Object as PropType<FormValues>,
      required: true,
    },
    answers: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },
  data: () => ({
    fetchingError: false,
    loading: true,
    quizResults: {} as QuizResults,
  }),
  created() {
    axios
      .get("/test-quiz.php", {
        params: {
          action: "submit",
          quizId: this.formValues.quizId,
          answers: this.answers,
        },
      })
      .then(({ data }) => {
        this.quizResults = data;
        this.loading = false;
      })
      .catch((error) => {
        if (error) {
          this.fetchingError = true;
        }
      });
  },
});
